import priceListStore from '@modules/price/price-list-store';
import priceViewStore from '@modules/price/price-view-store';
import priceImporterStore from '@modules/price/price-importer-store';
import priceFormStore from '@modules/price/price-form-store';
import priceDestroyStore from '@modules/price/price-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: priceDestroyStore,
    form: priceFormStore,
    list: priceListStore,
    view: priceViewStore,
    importer: priceImporterStore,
  },
};
